<div class="mydisplays-page">
    <!-- Header -->
    <app-generic-header
            [title]=" 'my_displays.my_displays' | translate "
            [searcher]="true"
            [divider]="false"
            (onSearch)="query.set($event)">
    </app-generic-header>

    <div class="cosentino-tab">
        <a [ngClass]="{'cosentino-tab-journey we': true, active: status() === 'all'}" (click)="status.set('all'); page.set(0)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{"my_displays.all" | translate}}</span>
                </div>
            </div>
        </a>
        <a  [ngClass]="{'cosentino-tab-journey we': true, active: status() === 'draft'}" (click)="status.set('draft'); page.set(0)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span class="">{{"my_displays.drafts" | translate}}</span>
                </div>
            </div>
        </a>
        <a  [ngClass]="{'cosentino-tab-journey we': true, active: status() == 'in_progress'}" (click)="status.set('in_progress'); page.set(0)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{"my_displays.requested" | translate}}</span>
                </div>
            </div>
        </a>
        <a  [ngClass]="{'cosentino-tab-journey we': true, active: status() === 'installed'}" (click)="status.set('installed'); page.set(0)">
          <div class="row slds-align-middle">
            <div class="slds-col">
                <span>{{"my_displays.approved" | translate}}</span>
            </div>
          </div>
        </a>
        <a  [ngClass]="{'cosentino-tab-journey we': true, active: status() === 'discontinued'}" (click)="status.set('discontinued'); page.set(0)">
            <div class="row slds-align-middle">
                <div class="slds-col">
                    <span>{{"my_displays.denied" | translate}}</span>
                </div>
            </div>
        </a>
    </div>
    <!-- displays List -->
    <div class="mydisplays-page__body flex flex-col lg:flex-row py-6 px-4 lg:p-8 gap-6">
      <div class="mydisplays-page__list order-2 lg:order-1">
        <app-displays-list [displays]="displays" [loaded]="loaded"></app-displays-list>
        <div *ngIf="hasNextPage()">
            <app-button [block]="true" (onClick)="loadNextPage()">
                {{ 'global.view_more' | translate }}
            </app-button>
        </div>
        <!-- app-displays-list-paginator -->
      </div>
      <div class="mydisplays-page__sidebar order-1 lg:order-2">
        <div class="w-full background-medium-02 flex flex-col">
          <div class="mydisplays-page__cta-content py-6 px-4">
            <img src="assets/icons/info.svg" class="display-list-item__value__edit-icon w-6 h-6 primaryDefault">
          </div>
          <div class="mydisplays-page__cta-content px-4">
            <p class="typography-title-m mt-0 mb-2">{{ 'my_displays.register_new_display' | translate }}</p>
          </div>
          <div class="mydisplays-page__cta-content mt-8 px-4">
              <app-button class="w-full" [secondary]="true" [size]="'large'" (click)="navigateToRegisterDisplay()">
                {{ 'my_displays.register_a_display' | translate }}
              </app-button>
            </div>
            <div class="mydisplays-page__cta-content py-6 px-4">
              <app-button class="w-full" [link]="true" [ghost]="true" (click)="navigateToPolicy()">
                {{ 'my_displays.policy' | translate }}
              </app-button>
          </div>
        </div>
      </div>
    </div>
</div>
